RivalIQ.apps.Alerts.module('views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';


    views.MetricAlert = views.Alert.extend({
        ui: {
            move: 'h1.metric.move-metric',
            posts: '.x-metric-posts'
        },
        metricPostsLimit: 3,
        endDateFormat: 'MMM D',
        startDateFormat: 'MMM D',
        template: '#alertsMetricAlertTemplate',
        hasMetricGrowth: function () {
            const me = this;
            return me.model.get('data').deltaRelative > 0;
        },
        isMetricVolumetric: function () {
            const me = this;
            return me.metricModel.getType() === RivalIQ.enums.metricType.VOLUME;
        },
        isEngagementMetric: function () {
            const me = this;
            return me.metricModel.get('category') === RivalIQ.enums.category.ENGAGEMENT;
        },
        getMetricPosts: function () {
            const me = this;
            return me.model.get('data').posts;
        },
        getMetricModel: function () {
            const me = this;
            return new RivalIQ.models.MetricDefinition(me.model.get('data').concept);
        },
        getAlertIconClassName: function () {
            const me = this;
            return RivalIQ.data.channels.get(me.metricModel.get('source')).get('fontIcon');
        },
        getAlertDescription: function () {

            const me = this;
            return [views.Alert.prototype.getAlertDescription.call(me), 'in 7 days'].join(' ');
        },
        getTimePeriod: function (data) {
            const me = this;
            data = data || me.model.toJSON();
            const timePeriod = RivalIQ.utils.timePeriod.createTimePeriodFromDuration(7, data.event_time);
            return timePeriod;
        },
        getPeriodDisplayString: function (data, period) {
            const me = this;
            const endFormat = me.endDateFormat;
            const startFormat = me.startDateFormat;
            const timePeriod = me.getTimePeriod(data);
            const start = timePeriod[`${period}Start`];
            const end = timePeriod[`${period}End`];

            return `${start.format(startFormat)} - ${end.format(endFormat)}`;
        },
        getMainPeriodDisplayString: function (data) {
            const me = this;
            const displayString = me.getPeriodDisplayString(data, 'mainPeriod');
            return displayString;
        },
        getComparePeriodDisplayString: function (data) {
            const me = this;
            const displayString = me.getPeriodDisplayString(data, 'comparePeriod');
            return displayString;
        },
        augmentTemplateData: function (data) {
            const me = this;

            views.Alert.prototype.augmentTemplateData.apply(me, arguments);

            data.metric = data.data;
            data.hasGrowth = me.hasMetricGrowth();
            data.isVolumetric = me.isMetricVolumetric(data);
            data.isEngagementMetric = me.isEngagementMetric(data);
            data.mainPeriodDisplayString = me.getMainPeriodDisplayString(data);
            data.comparePeriodDisplayString = me.getComparePeriodDisplayString(data);
        },
        onRender: function () {
            const me = this;
            const moveGrowthClassName = me.getMoveGrowthClassName();
            if (moveGrowthClassName) {
                me.ui.move.addClass(moveGrowthClassName);
            }

            if (me.isEngagementMetric()) {
                me.showMetricPosts();
            }
        },
        getMoveGrowthClassName: function () {
            const me = this;
            let className = null;
            const hasGrowth = me.hasMetricGrowth();

            if (hasGrowth) {
                className = 'metric-positive';
            } else {
                className = 'metric-negative';
            }

            return className;
        },
        showMetricPosts: function () {
            const me = this;
            const posts = me.getMetricPosts();

            if (!posts || posts.length === 0) {
                return;
            }

            const getPostPublishedAtDate = function (post) {
                return moment.utc(post.published_at).toDate();
            };

            const max = _.maxBy(posts, getPostPublishedAtDate);
            const min = _.maxBy(posts, getPostPublishedAtDate);

            const model = new Backbone.Model({
                metric: me.model,
                maxDate: max.published_at,
                minDate: min.published_at
            });

            new views.MetricAlertPosts({
                el: me.ui.posts.show(),
                model: model,
                companyData: me.companyData,
                dashboardModel: me.dashboardModel
            }).render();
        },
        initialize: function (options) {
            const me = this;
            _.extend(me, options);
            me.metricModel = new RivalIQ.models.MetricDefinition(me.model.get('data').concept);
        }
    });

}, window.moment);
